import { Helmet } from "react-helmet";

interface OrganizationSchemaProps {
  name?: string;
  url?: string;
  logo?: string;
  description?: string;
  email?: string;
  sameAs?: string[];
}

/**
 * Generates structured data for Organization following schema.org format.
 * This helps search engines understand your brand and display rich results.
 */
export function OrganizationSchema({
  name = "SendFeedback",
  url = "https://sendfeedback.ai",
  logo = "https://sendfeedback.ai/logo.png",
  description = "Anonymous employee feedback platform with AI-powered insights. Build trust, gather honest feedback, and create action plans.",
  email = "hello@sendfeedback.ai",
  sameAs = [
    "https://twitter.com/sendfeedbackai",
    "https://linkedin.com/company/sendfeedback",
  ],
}: OrganizationSchemaProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name,
    url,
    logo,
    description,
    email,
    sameAs,
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      email,
      url: `${url}/contact`,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
